<p class="color-muted">
  {{'THE_SQFT_VALUE_YOU_ENTERED_IS' | translate}} {{ wizard.model.percentage }}%
  <span style="text-decoration: underline;"> {{ wizard.model.avg | lowercase }}</span>
  {{'THE_AVERAGE_SQFT_FOR' | translate}} <span>{{ wizard.model.bannerName }}</span> {{'LOCATIONS' | translate}}.
  {{'THE_AVERAGE_SQFT_FOR_CAPITAL' | translate}}  <span>{{ wizard.model.bannerName }}</span>
  is <span>{{ wizard.model.avgSqft }} SQFT</span>.
  </p>
  <!-- SQFT_VALUE_MESSAGE here is the keu for the en translation -->
